import block from 'bem-cn-lite';
import {compose} from 'recompose';
import React, {Fragment} from 'react';
import {I18nKFunction, I18nOptions} from 'i18n';
import {Row} from '@yandex-data-ui/page-constructor';

import {getMktProductUrl} from '../../../../../common/marketplace/utils';
import withRouter, {WithRouterProps} from 'hoc/withRouter';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {NavigationItemExtended, ProductsByCategory} from 'models/app';
import {applySearch, getMarketplaceLink} from 'units/navigation/utils';
import {getFlatList} from 'utils/data';
import SearchNotFound from 'units/navigation/components/SearchNotFound/SearchNotFound';

import {ItemsProps, NavigationSectionType} from 'units/navigation/models';
import NavigationCategorizedItem from '../NavigationCategorizedItem/NavigationCategorizedItem';
import NavigationItemsTitle from 'units/navigation/components/NavigationItems/NavigationItemsTitle/NavigationItemsTitle';
import ListS from 'units/navigation/components/NavigationItems/ListS/ListS';
import Items from 'units/navigation/components/NavigationItems/Items/Items';
import ListMCards from 'units/navigation/components/NavigationItems/ListMCards/ListMCards';
import NavigationIcon, {
    NavigationItemTypes,
} from 'units/navigation/components/NavigationItems/NavigationIcon/NavigationIcon';

import './NavigationItems.scss';

const b = block('navigation-items');

export interface NavigationItemsOwnProps extends ItemsProps {
    products?: ProductsByCategory;
    search?: string;
    type?: NavigationSectionType;
}

type NavigationItemsProps = NavigationItemsOwnProps & WithRouterProps & WithTranslationProps;

class NavigationItems extends React.PureComponent<NavigationItemsProps> {
    flatList = getFlatList<NavigationItemExtended>(this.props.dataByCategory);

    render() {
        const {
            search,
            size,
            categories,
            dataByCategory,
            type = NavigationSectionType.Services,
            location = 'page',
        } = this.props;

        return (
            <div className={b({size})}>
                {search ? (
                    this.renderSearchResult(search)
                ) : (
                    <Fragment>
                        <Items
                            categories={categories}
                            dataByCategory={dataByCategory}
                            size={size}
                            type={type}
                            location={location}
                        />
                        {this.props.products && this.renderListProducts()}
                    </Fragment>
                )}
            </div>
        );
    }

    private i18nK: I18nKFunction = (key: string, params?: I18nOptions) =>
        this.props.i18n(this.props.type || NavigationSectionType.Services, key, params);

    private renderSearchResult(search: string) {
        const result = applySearch(search, this.flatList);
        const {size, location, type = NavigationSectionType.Services} = this.props;

        return (
            <div className={b('search-result')} data-qa="search-result">
                {result.length ? (
                    <Fragment>
                        <h4>{this.i18nK('search-found', {count: result.length})}</h4>
                        {size === 's' ? (
                            <ListS
                                navigationItems={result}
                                location={location}
                                type={type}
                                size={size}
                            />
                        ) : (
                            <ListMCards navigationItems={result} type={type} />
                        )}
                    </Fragment>
                ) : (
                    <SearchNotFound
                        notFoundDescription={this.i18nK('search-not-found-description')}
                    />
                )}
            </div>
        );
    }

    private renderListProducts() {
        const {categories, products, size} = this.props;

        if (!products) {
            return null;
        }

        const marketplaceUrl = getMarketplaceLink();

        return (
            <div className={b('category')}>
                {categories.map((category) => {
                    const {slug} = category;
                    const categoryProducts = products[slug];

                    if (!categoryProducts || !categoryProducts.length) {
                        return null;
                    }

                    return (
                        <Fragment key={slug}>
                            <NavigationItemsTitle
                                name={this.i18nK('marketplace-navigation-title')}
                                slug={slug}
                                url={marketplaceUrl}
                                dataQa={'list-products'}
                            />
                            <Row>
                                {categoryProducts.map((categoryProduct) => {
                                    const url = getMktProductUrl(categoryProduct.name);
                                    const icon = (
                                        <NavigationIcon
                                            type={NavigationItemTypes.Products}
                                            iconProps={{src: categoryProduct.marketingInfo.logo}}
                                        />
                                    );

                                    return (
                                        <NavigationCategorizedItem
                                            key={categoryProduct.id}
                                            id={categoryProduct.id}
                                            url={url}
                                            title={categoryProduct.marketingInfo.name || ''}
                                            dataQa="navigation-product"
                                            size={size}
                                            type={NavigationItemTypes.Products}
                                            icon={icon}
                                        />
                                    );
                                })}
                            </Row>
                        </Fragment>
                    );
                })}
            </div>
        );
    }
}

export default compose<NavigationItemsProps, NavigationItemsOwnProps>(
    withRouter,
    withTranslation(),
)(NavigationItems);
